module.exports = __webpack_public_path__ + "static/img/头像1.b004914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像1.png
// module id = 9cHm
// module chunks = 1